/** `1 << 31` seconds — UPnP/Java unknown-length sentinel (Chet Razer #1021). */
export const DURATION_SENTINEL_SECS = 2_147_483_648;
const MAX_TRUSTED_SECS = 36_000;

export function isDurationSentinel(durationSecs: number | undefined | null): boolean {
  return durationSecs != null && Number.isFinite(durationSecs) && durationSecs >= DURATION_SENTINEL_SECS;
}

export function isAdvanceGuardDurationTrustworthy(
  durationSecs: number | undefined | null,
): boolean {
  return durationSecs != null
    && Number.isFinite(durationSecs)
    && durationSecs > 0
    && durationSecs < DURATION_SENTINEL_SECS
    && durationSecs <= MAX_TRUSTED_SECS;
}

export function trustedRendererDuration(
  reported: number | undefined,
  stored: number | undefined,
): number {
  if (isAdvanceGuardDurationTrustworthy(reported)) return reported as number;
  if (isAdvanceGuardDurationTrustworthy(stored)) return stored as number;
  return 0;
}

export function trustedStallDuration(store: {
  duration: number;
  currentTrack?: Record<string, unknown> | null;
}): number {
  if (isAdvanceGuardDurationTrustworthy(store.duration)) return store.duration;
  const t = store.currentTrack;
  if (!t) return 0;
  const raw = Number(t.duration ?? t.duration_sec ?? t.duration_seconds);
  if (isAdvanceGuardDurationTrustworthy(raw)) return Math.floor(raw);
  const ms = Number(t.duration_ms);
  const fromMs = Number.isFinite(ms) && ms > 0 ? Math.floor(ms / 1000) : 0;
  return isAdvanceGuardDurationTrustworthy(fromMs) ? fromMs : 0;
}
